import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { images } from '../../lib/config';
import { getAuthToken } from '../../utils/guestStorage';
import './Header.css';

const Header = ({ onNavigationClick }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoggedIn(Boolean(getAuthToken()));
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/application', label: 'APPLICATION' },
    { path: '/blog', label: 'BLOG' },
    { path: '/about', label: 'ABOUT US' },
    { path: '/contact', label: 'CONTACT US' },
    { path: '/template', label: 'TEMPLATE' }
  ];

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleNavClick = () => {
    if (onNavigationClick) {
      onNavigationClick();
    }
    closeDrawer();
  };

  useEffect(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isDrawerOpen]);

  useEffect(() => {
    closeDrawer();
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="header header-container-main">
      <div className="container">
        <div className="header-container">
          <Link to="/" className="header-logo" onClick={handleNavClick}>
            <img src={images.ledIcon1} alt="LED Scroller Logo" className="logo-image" />
          </Link>

          <nav className="header-nav-desktop">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to={isLoggedIn ? '/profile' : '/login'}
              className={`nav-link header-login-link ${
                isActive('/login') || isActive('/profile') ? 'active' : ''
              }`}
              onClick={handleNavClick}
            >
              {isLoggedIn ? 'PROFILE' : 'LOGIN'}
            </Link>
          </nav>

          <button
            type="button"
            className={`hamburger-button ${isDrawerOpen ? 'open' : ''}`}
            onClick={toggleDrawer}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <div
        className={`drawer-overlay ${isDrawerOpen ? 'open' : ''}`}
        onClick={closeDrawer}
        role="presentation"
      />
      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <Link to="/" className="drawer-logo" onClick={handleNavClick}>
            <img src={images.ledIcon1} alt="LED Scroller Logo" className="logo-image" />
          </Link>
          <button
            type="button"
            className="drawer-close"
            onClick={closeDrawer}
            aria-label="Close menu"
          >
            <span>&times;</span>
          </button>
        </div>
        <nav className="drawer-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`drawer-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to={isLoggedIn ? '/profile' : '/login'}
            className={`drawer-link ${
              isActive('/login') || isActive('/profile') ? 'active' : ''
            }`}
            onClick={handleNavClick}
          >
            {isLoggedIn ? 'PROFILE' : 'LOGIN'}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
